<template>
    <div class="sanitationQuery">
        <div class="query-content">
            <el-form :model="queryformdata" :inline="true" style="margin-bottom: 20px;">
                <el-form-item label="楼栋" v-if="role != 'headmaster'">
                    <template v-if="role === 'admin' || role === 'logisticsadmin'">
                        <v-combotree style="width: 190px;" @node-click="deptTreeNodeHandleClick" placeholder="请选择楼栋" :props="deptProps" :data="buildingData" :model="queryformdata.houseName"></v-combotree>
                    </template>
                    <el-select v-if="role === 'housekeeper'" v-model="queryformdata.houseId" placeholder="请选择楼栋" style="width:150px;margin-top:5px;" :disabled="HouseByManagerUserCombobox.length < 2">
                        <el-option v-for="item in HouseByManagerUserCombobox" :key="item.houseId" :label="item.houseName" :value="item.houseId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级" v-if="role === 'headmaster'">
                	<el-select  v-model="queryformdata.classId" placeholder="请选择班级" style="width:150px;margin-top:5px;" :disabled="classAreaList.length < 2">
                        <el-option v-for="item in classAreaList" :key="item.id" :label="item.className" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="宿舍名" style="margin-right: 8px;">
                    <el-input placeholder="请输入宿舍名" v-model="queryformdata.dormitoryName"></el-input>
                </el-form-item>
                <el-form-item label="日期" style="margin-right: 8px;">
                    <el-date-picker ref="startTime" :clearable="false" v-model="queryformdata.startTime" type="date" value-format="yyyy-MM-dd" @change="startDateChange">
                    </el-date-picker>

                </el-form-item>
                <el-form-item label="-">
                    <el-date-picker ref="endTime" :clearable="false" v-model="queryformdata.endTime" type="date" value-format="yyyy-MM-dd" :picker-options="endtimepickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="卫生评级">
                    <el-select v-model="queryformdata.level">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="item in sanitationCombobox" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div style="display: inline-block;margin-bottom:10px">
                    <ul class="tag">
                        <li v-for="(item, index) in tags" :key="index" @click="clickTags(item)" :class="{'active':　item.tagActive}">{{item.name}}</li>
                    </ul>
                </div>
                <div style="float: right;margin: 7px 20px 0 0">
                    <el-button type="primary" class="query" @click="loadDataInFirstPage">查询</el-button>
                    <el-button class="reset" @click="reset">重置</el-button>
                    <el-button icon="el-icon-download" type="primary" @click="exportExl">导出记录</el-button>
                </div>
            </el-form>

        </div>

        <div class="tableList">
            <template>
                <el-table border stripe :data="dataList" header-row-class-name="table-header" style="width: 1200px;">

                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="dormitoryName" label="宿舍" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="houseName" label="楼栋" width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="role==='headmaster'" prop="studentList" label="学生" width="200" align="center">
                    </el-table-column>
                     <el-table-column v-else prop="childSchoolName" label="园区" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="scoreDate" label="日期" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="score" label="卫生评级" width="309" align="center">
                        <span slot-scope="scope">
                            <el-rate v-model="scope.row.score" disabled></el-rate>
                            <span :class="scoreROW(scope.row.score).class">({{scoreROW(scope.row.score).text}})</span>
                        </span>
                    </el-table-column>

                </el-table>
            </template>
            <div class="pagination-container ">
                <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :page="page"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import combotree from '@/components/combotree/combotree.vue'
import basetable from '@/mixins/base-table';
import { session } from '@/util'

export default {
    components: {
        vCombotree: combotree

    },
    props: {
        //  classAreaList: {
        //     type: Array,
        //     default: () => []
        // }
    },
    mixins: [basetable],
    data () {
        let vm = this;
        let token = session('token').accesstoken;
        return {
        	token:token,
            queryformdata: {
                houseId: '',
                houseName: '',
                schoolNum: '',
                startTime: '',
                endTime: '',
                level: '',
                lvlType: '',
                dormitoryName: '',
                classId:'',
            },
            tags: [
                { id: 1, name: '连续优秀寝室' },
                { id: 2, name: '连续合格寝室' },
                { id: 3, name: '连续不合格寝室' }
            ],
            HouseByManagerUserCombobox: [],
            buildingData: [],
            deptProps: {
                label: "lable",
                isLeaf: "leaf",
                children: "children"
            },
            sanitationCombobox: [
                { id: '2', name: '优秀' },
                { id: '1', name: '合格' },
                { id: '0', name: '不合格' }
            ],

            endtimepickerOptions: {
                disabledDate (time) {
                    if (vm.queryformdata.startTime) {
                        return time < new Date(vm.queryformdata.startTime + ' 00:00:00').getTime();
                    }
                    return false;
                },
            },
            doNotInit: true,
			classAreaList:[],
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ]),
        role () {
            return this.user.tsr ? this.user.tsr.roleCode : '';
        }

    },
    methods: {

        startDateChange (v) {
            this.queryformdata.endTime = v;
        },
        scoreROW (score) {
            if (score > 3) {
                return {
                    class: 'green',
                    text: '优秀'
                }
            }
            if (score === 3) {
                return {
                    class: 'orange',
                    text: '合格'
                }
            } else {
                return {
                    class: 'red',
                    text: '不合格'
                }
            }
        },
        // 返回当天年月日
        _setCurrentTime () {
            let date = new Date();
            let year = date.getFullYear();
            let month = this._padZero(date.getMonth() + 1);
            let day = this._padZero(date.getDate());
            return [year, month, day].join("-");
        },
        _padZero (str) {
            let start = str.length == 2 ? 0 : 1;
            return ("0" + str).substring(start);
        },
        loadData () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            var roleType = this.role === 'admin' || this.role === 'logisticsadmin'? 1 : this.role === 'housekeeper' ? 2 : this.role === 'headmaster' ? 3 : '';
            let param = {
                schoolId: this.user.schoolId,
                schoolNum: this.queryformdata.schoolNum,
                houseId: this.queryformdata.houseId,
                lvl: this.queryformdata.level || undefined,
                lvlType: this.queryformdata.lvlType || undefined,
                startDate: this.queryformdata.startTime || undefined,
                endDate: this.queryformdata.endTime || undefined,
                dormitoryName: this.queryformdata.dormitoryName || undefined,
                classId:this.queryformdata.classId,
                roleType:roleType,
            };
            api.sanitationManage.houseHealthList(param, this.page, this.size).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    this.dataList = data.list;
                } else {
                    this.$message(res.message);
                }
            });
        },
        loadDataInFirstPage () {
            this.page === 1 ? this.loadData() : this.page = 1;
        },
        reset () {
            if (this.role === 'housekeeper') {
                var houseId;
                if (this.HouseByManagerUserCombobox && this.HouseByManagerUserCombobox.length > 0) {
                    houseId = this.HouseByManagerUserCombobox[0].houseId;
                }

                this.queryformdata = {
                    houseId,
                    houseName: '',
                    schoolNum: '',
                    startTime: this._setCurrentTime(),
                    endTime: this._setCurrentTime(),
                    level: '',
                    lvlType: '',
                    dormitoryName: '',
                };

            }
            if (this.role === 'admin' || this.role === 'logisticsadmin') {
                this.queryformdata = {
                    houseId: '',
                    houseName: '',
                    schoolNum: '',
                    startTime: this._setCurrentTime(),
                    endTime: this._setCurrentTime(),
                    level: '',
                    lvlType: '',
                    dormitoryName: '',
                };
            }
			 if (this.role === 'headmaster') {
			 	var classId;
                if (this.classAreaList && this.classAreaList.length > 0) {
                    classId = this.classAreaList[0].id;
                }
                this.queryformdata = {
                	houseId: '',
                    houseName: '',
                    schoolNum: '',
                    startTime: this._setCurrentTime(),
                    endTime: this._setCurrentTime(),
                    level: '',
                    lvlType: '',
                    dormitoryName: '',
                    classId,
                };
            }
            this.tags.forEach(item => { if (item.tagActive) item.tagActive = false });
        },
        exportExl () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            var roleType = this.role === 'admin'|| this.role === 'logisticsadmin' ? 1 : this.role === 'housekeeper' ? 2 : this.role === 'headmaster' ? 3 : '';
            let param = {
                schoolId: this.user.schoolId,
                schoolNum: this.queryformdata.schoolNum || undefined,
                houseId: this.queryformdata.houseId + '' || undefined,
                lvl: this.queryformdata.level || undefined,
                lvlType: this.queryformdata.lvlType || undefined,
                startDate: this.queryformdata.startTime || undefined,
                endDate: this.queryformdata.endTime || undefined,
                dormitoryName: this.queryformdata.dormitoryName || undefined,
                roleType:roleType,
                classId:this.queryformdata.classId
            };
            api.sanitationManage.houseHealthListExport(param, this.page, this.size).then(response => {
                let blob = new Blob([response], { type: 'application/x-xls' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = '宿舍卫生查询.xls';
                link.click()
            })

        },
        clickTags (item) {
            let active = item.tagActive;
            this.tags.forEach(item => { if (item.tagActive) item.tagActive = false });
            this.$set(item, 'tagActive', !active);
            this.queryformdata.lvlType = item.tagActive ? item.id : '';
            this.queryformdata.level  = item.id == '1'?'2':item.id == '2'?'1':'0'
        },
        deptTreeNodeHandleClick (data) {
            this.queryformdata.houseId = '';
            this.queryformdata.schoolNum = '';
            if (data.leavel == 1) {
                this.queryformdata.schoolNum = data.schoolNum + '';
            }
            if (data.leavel == 2) {
                this.queryformdata.houseId = data.id + '';
            }
            this.queryformdata.houseName = data.lable;
        },
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                    return res.data;
                } else {
                    this.$message(res.message);
                }
            });
        },
         //根据班主任获取班级
        getClassarealist(){
        	return api.systemConfig.qryMasterClasses(this.token).then(res => {
                if (res.code == 0) {
                    this.classAreaList = res.data;
                    return res.data;
                } else {
                    this.$message(res.message)
                }
            })
        },
    },
    created () {
        this.queryformdata.startTime = this._setCurrentTime();
        this.queryformdata.endTime = this._setCurrentTime();
        if (this.role === "housekeeper") {
            this.queryHouseByManagerUser().then((data) => {
                this.queryformdata.houseId = this.HouseByManagerUserCombobox[0].houseId;
                this.queryformdata.houseName = this.HouseByManagerUserCombobox[0].houseName;
                this.loadData();

            });

        }
        if (this.role === "headmaster") {
            this.getClassarealist().then((data) => {
                this.queryformdata.classId = this.classAreaList[0].id;
                this.queryformdata.className = this.classAreaList[0].className;
                this.loadData();
            });

        }
        if (this.role === 'admin' || this.role === 'logisticsadmin') {
            api.common.querySchoolHouseTree(this.user.schoolId).then(res => {
                if (res.code == 0) {
                    this.buildingData = res.data.treeDTOList;
                    this.loadData();

                } else {
                    this.$message(res.message);
                }
            });
        }
    },
    mounted () {

    }
}
</script>
<style lang="scss" >
.sanitationQuery {
  padding: 20px 0;
  .el-rate {
    display: inline-block;
  }
  .green {
    color: #00cdcd;
  }
  .orange {
    color: #ffb324;
  }
  .red {
    color: red;
  }
  .el-form-item {
    display: inline-block;
    height: 40px;
    margin-bottom: 10px;
    margin-right: 20px;
  }
  .query-content {
    margin-bottom: 20px;
  }
  .tag {
    & > li {
      display: inline-block;
      vertical-align: top;
      min-width: 129px;
      padding: 8px 25px;
      background-color: rgb(246, 246, 246);
      color: #666;
      margin: 5px 15px 0 0;
      text-align: center;
      font-size: 13px;
      border-radius: 4px;
      cursor: pointer;
      &.active {
        background-color: #f0b06a;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/sanitationManage/sanitationQuery.vue